@if (company$ | async) {
  <div class="smartphoto-create">
    <p class="smartphoto-create__title">{{ 'create_smartphoto_title' | i18nextEager }}</p>
    @if (createForm) {
      <form [formGroup]="createForm" (ngSubmit)="createSmartphoto()" class="smartphoto-create__form">
        <bdeo-input
          data-test-id="caseRef-input"
          formControlName="case"
          type="form"
          size="medium"
          variant="text"
          placeholder="{{ 'create_form.case_placeholder' | i18nextEager }}"
          label="{{ 'create_form.case_label' | i18nextEager }}"
          value=""
          [error]="errors.case"
          (blur)="errors.case = undefined"
          ngDefaultControl
          required
        >
          <div slot="help-text">{{ errors.case }}</div>
        </bdeo-input>
        @for (field of fields; track $index) {
          @if (field.type === 'list') {
            <bdeo-select
              [attr.data-test-id]="'select-input-' + field.properties[0]"
              formControlName="{{ field.properties[0] }}"
              type="form"
              size="medium"
              [required]="field.required || false"
              placeholder="{{ field.placeholder }}"
              label="{{ field.label }}"
              [addNew]="true"
              [options]="field.options"
              ngDefaultControl
            />
          } @else if (field.type === 'date') {
            <bdeo-date-picker
              label="{{ field.label }}"
              formControlName="{{ field.properties[0] }}"
              placeholder="{{ field.label }}"
              [minDate]="deadLineMinDate"
              [required]="field.required || false"
              position="bottom left"
              ngDefaultControl
            >
            </bdeo-date-picker>
          } @else {
            <bdeo-input
              formControlName="{{ field.properties[0] }}"
              type="form"
              size="medium"
              variant="{{ field.type }}"
              placeholder="{{ field.placeholder }}"
              label="{{ field.label }}"
              value=""
              ngDefaultControl
              [required]="field.required || false"
            />
          }
        }
        <bdeo-button
          data-test-id="submit-create"
          size="medium"
          type="primary"
          text="{{ 'create_form.create_button' | i18nextEager }}"
          [icon]="loading ? 'loading-circle' : ''"
          [disabled]="!createForm.valid || createForm.pristine || loading"
          (click)="createSmartphoto()"
        ></bdeo-button>
      </form>
    }
  </div>
}
